import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { ApiService } from '../../service/api_service';
import { tourprogramlist } from '../../model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
//import { dropRight } from 'lodash';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-addtourprogram',
  template: require('./addtourprogram.component.html'),
  styles: [require('./addtourprogram.component.css')]
})
export class AddTourProgramComponent implements OnInit {
  formgroup: FormGroup;
  showMyContainer: boolean = false;
  private columnDefs;
  private rowData: any[];
  private rowHeight;

  api: GridApi;
  id: any;
  busy: Subscription;
  date1: any;
  columnApi: ColumnApi;
  private gridColumnApi;
  defaultColDefine;
  month_num: number;
  empData: any = [];
  empId: number;
  tpData: any = [];
  routeData: any = [];
  count: number = 0;
  updateListData: any = [];
  routes: any;
  chemistmasterdataModel: tourprogramlist = new tourprogramlist();
  firstDate: string;
  lastDate: string;
  stateList: any = [];
  empName: any = [];
  headQuarterList: any = [];
  currentDate: any;
  api1: any;
  columnApi1: any;
  employeeData: any = [];
  columnDefsPopup: any;
  token: any;
  private gridColumnApi1;
  @ViewChild('close') public modal: ElementRef;
  static parameters = [ApiService, ActivatedRoute, Router]
  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    let parent = this;

    this.columnDefs = [
      { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 90 },
      { headerName: 'Employee Code', field: 'Client_Code' },
      {
        headerName: 'Employee Name', field: "Client_Name", cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `
                <div class="grid_actions">
                    <span class="grid_actions_item" data-target="#EmployeeRecord" data-toggle="modal"><a class="viewBtn btn btn-link">`+ params.data.Client_Name + `</a></span>
                </div>
                `;
          var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
          viewButton.addEventListener('click', function () {
            parent.tracking(params.data);
          });
          return eDiv;
        }
      },
      { headerName: 'Head Qtr.', field: "HQName" },
      { headerName: 'Designation.', field: "Designation" },
      { headerName: 'Submit Date.', field: "SubmitDate" },
      { headerName: 'Approved Date', field: 'ApprovedDate', width: 150 },
      {
        headerName: 'Approved By', field: "ApprovedBy", width: 150
      },
      {
        headerName: 'Action', field: "Action", pinned: "right", cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          if (params.data.Status == 0) {
            eDiv.innerHTML = `
                <div class="grid_actions" id="Action_`+ params.data.EmpID + `">
                    <span class="ApproveBtn grid_actions_item mr-1" ><button class="btn btn-primary">Approve</button></span>
                    <span class="RejectBtn grid_actions_item mr-1" ><button class="btn btn btn-danger">Reject</button></span>
                    
                </div>
                `;
            var ApproveButton = eDiv.querySelectorAll('.ApproveBtn')[0];
            ApproveButton.addEventListener('click', function () {
              parent.Updatestatus(params.data, 1);
            });
            var RejectButton = eDiv.querySelectorAll('.RejectBtn')[0];
            RejectButton.addEventListener('click', function () {
              parent.Updatestatus(params.data, 2);
            });
          }
          return eDiv;
        }
      }
    ];


    this.columnDefsPopup = [
      { headerName: 'Date', field: 'Date', width: 150 },
      {
        headerName: 'Working Option', field: "WorkingOption", width: 150
      },
      {
        headerName: 'Work with', field: "WorkWith", width: 150
      },
      {
        headerName: 'Route', field: "RouteName", width: 350
      },

      {
        headerName: 'Objective of the Day / Remark/Contact Point & Time', field: "Objective", width: 420
      }
    ];
    // this.rowData = [
    //       { sno: '1', EmployeeCode: 'Delhi To Gurugram', EmployeeName: 'L', HeadQtr: 0, Designation: 12, Division: 0, SubmitDate: 12
    //       ,ApprovedDate:'03/06/2021',ApprovedBy:'rakesh',
    //      },

    //     ];
    //this.defaultColDefine = { resizable: true };

    this.rowHeight = 50;

  }

  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.chemistmasterdataModel.StateID = 0;
    this.chemistmasterdataModel.HQ = '0';
    this.chemistmasterdataModel.Approval = "0";
    var date = new Date();
    this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
    this.chemistmasterdataModel.currentMonth = this.currentDate;
    this.formgroup = this.tourprogramlist_Form;
    $('#filter-option').trigger('click');


    this.getState();
    this.getHeadQuarterList();
  }

  tourprogramlist_Form = new FormGroup({
    currentmonth: new FormControl(),
    hq: new FormControl(),
    approval: new FormControl(),
    state: new FormControl(),
  });
  onGridReady1 = (params) => {
    this.api1 = params.api;
    this.gridColumnApi1 = params.columnApi;
    //this.api1.showNoRowsOverlay();
  }
  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();
  }
  getHeadQuarterList() {
    this.apiService.getHeadQuarterList().subscribe((res: any) => {
      this.headQuarterList = res.data;
    })
  }


  getState() {
    this.apiService.getState().subscribe((res: any) => {
      this.stateList = res.data;
    })
  }

  onBtnExport() {
    this.api.exportDataAsCsv({ fileName: 'tourprogramlist' });
  }


  Updatestatus(data, statustype) {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    var queryData = {
      date: this.formgroup.value.currentmonth,
      EmpId: data.EmpID,
      type: statustype,
      ApproveBy: token.clientId,

    }
    console.log(queryData);
    this.busy = this.apiService.ApproveTourPlan_Web(queryData)
      .subscribe((res: any) => {
        console.log(res);
        if (res.length > 0) {
          if (res[0].flag) {
            $('#Action_' + data.EmpID).hide();
            alert("Tour Program " + (statustype == 1 ? `Approved` : `Rejected`) + " Successfully");
            this.filterData();
          } else {
            alert(res[0].msg);
          }
        }

      })

  }

  tracking(data) {
    var queryData = {
      date: this.formgroup.value.currentmonth,
      EmpId: data.EmpID,

    }
    this.employeeData = [];
    console.log(queryData);
    this.busy = this.apiService.GetTourProgramList(queryData)
      .subscribe((res: any) => {
        this.employeeData = res.employee;

      })

  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }

  filterData() {
    console.log(this.formgroup.value);
    let approval;
    if (this.formgroup.value.approval != 0) {
      approval = this.formgroup.value.approval;
    } else {
      approval = '0'
    }
    var queryData = {
      date: this.formgroup.value.currentmonth,
      HQ: this.formgroup.value.hq,
      StateID: this.formgroup.value.state,
      approval: approval,
      LoginId: this.token.id
    }
   // console.log(queryData);
    this.modal.nativeElement.click();
    this.busy = this.apiService.GetTourProgramEmployeeList(queryData)
      .subscribe((res: any) => {
        this.rowData = res.employee;

      })

  }

}
